// ** React Imports
import { Outlet } from 'react-router-dom'

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout'

// ** Menu Items Array
import navigation from '@src/navigation/vertical'
import { memo, useCallback, useEffect, useState } from 'react'
import { isUserLoggedIn } from '@utils'
import { users } from '../db/users'
import { checkIsCrediQ } from '../utility/utils'
import { getIssuerConfigRequest, getTemporalToken } from '../billing-api'

//** ComponentDidMount

const filterChildren = (navigation, idsToFilter) => {
  return navigation
    .map((item) => {
      if (item.children) {
        const filteredChildren = item.children.filter((child) =>
          idsToFilter.includes(child.id)
        )
        if (filteredChildren.length > 0) {
          return {
            ...item,
            children: filteredChildren,
          }
        }
      }
      return null // Retornamos null si no hay hijos filtrados
    })
    .filter((item) => item !== null) // Filtramos los nulls
}

const VerticalLayout = memo((props) => {
  const [menuData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  const [userData, setUserData] = useState(null)

  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem('userData')))
    }
  }, [])

  const filteredNavigation = useCallback(async () => {
    // console.log('loop:', { userData })
    const userName = JSON.parse(localStorage.getItem('userBilligData'))
    const userLogin = { companyId: userName?.username }
    const user = users.find(
      (user) => user?.companyId === userLogin?.companyId
    )
    // console.log('user:', user)
    const isCrediQ = checkIsCrediQ(user?.userName)

    let enableReceptionDocs = true
    let navResult = []

    try {
      const token = await getTemporalToken(user)
      const response = await getIssuerConfigRequest(token, user.userId)

      enableReceptionDocs = response?.isActive ?? false
    } catch (error) {
      enableReceptionDocs = false
    }

    const checkAccessBusinessManager = (value) =>
      value.reduce((accumulator, current) => {
        if (current.id === 'temporal-billing') {
          accumulator.push({
            ...current,
            children: current.children.filter((item) => {
              if (item.id === 'business-manager') {
                return userData?.role === 'administrador' && isCrediQ
              }

              return true
            }),
          })
        } else {
          accumulator.push(current)
        }

        return accumulator
      }, [])

    if (
      userData?.Company === '9' ||
      userData?.Company === '13' ||
      userData?.Company === '14' ||
      userData?.Company === '15' ||
      userData?.Company === '16' ||
      userData?.Company === '20'
    ) {
      // Si la compañía es 9, mostrar solo facturación

      navResult = navigation.filter((n) => n.id === 'billing')
    } else if (userData?.Company === '11' || userData?.Company === '12') {
      navResult = checkAccessBusinessManager(
        navigation.filter((n) => n.id === 'temporal-billing')
      )
    } else if (userData?.role.startsWith('admin')) {
      navResult = checkAccessBusinessManager(
        navigation.filter(
          (n) => n.id === 'digitalSignature' || n.id === 'temporal-billing'
        )
      )
    } else if (
      userData?.role.startsWith('agent') ||
      userData?.role.startsWith('supervisor')
    ) {
      const navigationSignature = checkAccessBusinessManager(
        navigation.filter(
          (n) => n.id === 'digitalSignature' || n.id === 'temporal-billing'
        )
      )

      navResult = navigationSignature.filter(
        (n) => !['societies', 'usuario', 'Area'].includes(n.id)
      )
    } else if (userData?.role.startsWith('consultor')) {
      const navigationSignature = checkAccessBusinessManager(
        navigation.filter(
          (n) => n.id === 'digitalSignature' || n.id === 'temporal-billing'
        )
      )
      const idsToFilter = ['documents', 'home', 'invoices', 'docs-error']

      navResult = filterChildren(navigationSignature, idsToFilter)
    } else {
      const navigationSignature = checkAccessBusinessManager(
        navigation.filter(
          (n) => n.id === 'digitalSignature' || n.id === 'temporal-billing'
        )
      )

      navResult = navigationSignature.filter((n) => n.id !== 'usuario')
    }

    navResult = navResult.reduce((accumulator, current) => {
      if (current.id.includes('billing')) {
        accumulator.push({
          ...current,
          children: current.children.filter((item) => {
            if (['freception', 'tbreception'].includes(item.id)) {
              return enableReceptionDocs
            }

            return true
          })
        })
      } else {
        accumulator.push(current)
      }

      return accumulator
    }, [])

    return navResult
  }, [userData])

  useEffect(() => {
    if (!userData) return

    filteredNavigation()
      .then((data) => {
        setMenuData(data)
      })
  }, [userData])

  //console.log("filteredNavigation: ", filteredNavigation())

  return (
    <Layout
      menuData={
        menuData
        /*userData?.role.startsWith('admin')? navigation: userData?.role?.startsWith('agent') ||
            userData?.role?.startsWith('supervisor')? navigation.filter(
              (n) => !['societies', 'usuario', 'Area'].includes(n.id)
            ): userData?.role?.startsWith('consultor')? navigation.filter((n) => ['documents', 'home', 'invoices', 'docs-error'].includes(n.id)): navigation.filter((n) => n.id !== 'usuario')*/
      }
      {...props}
    >
      <Outlet />
    </Layout>
  )
})

export default VerticalLayout
